module.exports = __webpack_public_path__ + "static/media/PushtimargImage15.661f815b.gif";